$(document).ready(function () {
    $(document).on('click', '.modal_open', function () {
        const bgModal = '<div class="bg_modal_window"></div>';
        const modalName = $(this).attr('data-modal');
        const grennZone = $(this).closest('#color_style_green').length;

        if (grennZone == 1) {
            $('.modal_wrap').find('.submit_bue_click, .global_button_blue').css({
                "background": "#78dc00",
                "border": "1px solid #78dc00"
            })
        }

        if ($('.bg_modal_window').length == 0) {
            $('footer').after(bgModal);
        }

        switch (modalName) {
            case 'buyOneClick':
                if ($(this).hasClass('js__good_page_btn')) {
                    $(this).addClass('btn_buy');
                }
                if ($(this).hasClass('js__add_cart_one_click')) {
                    const objectBuy = {
                        "name": $(this).text(),
                        "guid": $(this).attr('data-guid'),
                        "id": $(this).attr('data-id'),
                        "price_type_id": $(this).attr('data-price_type_id'),
                        "item_type": $(this).attr('data-item_type'),
                        "itemListNameGtm": $(this).attr('data-itemListNameGtm'),
                        "indexGtm": $(this).attr('data-indexGtm'),
                        "quantity": $(this).closest('.js__quantity_block').find('.js__count_input').val()
                    };
                    buyOneClickProductPage(modalName, true, objectBuy);
                } else {
                    buyOneClickProductPage(modalName);
                }
                break;

            case 'addToWaitlist':
                $(this).addClass('js__anker_here');
                let itemType = $(this).attr('data-item_type');
                if (typeof itemType !== typeof undefined && itemType !== false) {
                    itemType = itemType;
                } else {
                    itemType = "";
                }
                const objectAvailability = {
                    "id": $(this).attr('data-id'),
                    "itemType": itemType,
                };
                addToWaitlist(modalName, objectAvailability);
                break;

            case 'goodSignService':
                const nodeGtm = $(this).closest('.service_offers_item').find('.name_service p').attr('data-nameGtm');
                const objectSignService = {
                    "article": $(this).attr('data-article'),
                    "id": $(this).attr('data-id'),
                    "serviceName": nodeGtm ? nodeGtm : $(this).closest('.transport_card_item').find('.transport_card_title p').attr('data-nameGtm'),
                }
                goodSignService(modalName, objectSignService)
                break;

            case 'callbackServiceAddress':
                const addressContentBlockInfo = $(this).closest('.all_info').find(`.js__address_container.active[data-type=info]`);
                const addressContentBlockService = $(this).closest('.all_info').find(`.js__address_container.active[data-type=service]`);

                const listServise = addressContentBlockService.find('.services_list_department').html();
                const firstItemList = {
                    "id": addressContentBlockService.find('.services_list_department li').first().attr('data-id'),
                    "name": addressContentBlockService.find('.services_list_department li span').first().attr('data-nameGtm'),
                    "article": addressContentBlockService.find('.services_list_department li').first().attr('data-article'),
                    "city": addressContentBlockInfo.find('.js__city_gtm').attr('data-nameGtm'),
                    "city_id": addressContentBlockInfo.find('.js__city_gtm').attr('data-city_id'),
                    "address_id": addressContentBlockInfo.find('.js__address_gtm').attr('data-address_id'),
                    "address": addressContentBlockInfo.find('.js__address_gtm').attr('data-nameGtm')
                }
                const typePage = $(this).attr('data-typePage');
                callbackServiceAddress(modalName, listServise, firstItemList, typePage);
                break;

            case 'returnGoods':
            case 'returnGood':
                $('.js__input_return').remove();
                const dataReturnGood = {
                    "guid": $(this).attr('data-guid'),
                    "id": $(this).attr('data-id'),
                    "order": $(this).attr('data-order'),
                }
                if (modalName == "returnGood") {
                    const name = $(this).closest('.js__return_good_item').find('.name').text();
                    dataReturnGood.name = name;
                }
                returnGoodModal(modalName, dataReturnGood);
                break;

            case 'phoneModal':
                const phoneList = $('.phone_list .dropdawn_list').html();
                $(`.modal_wrap[data-modal=${modalName}] .modal_middle`).empty().append(phoneList);
                $(`.modal_wrap[data-modal=${modalName}] .modal_middle`).append('<li class="main_phone_li"></li>')
                $('.phone_list .js_main_phone').clone().appendTo(`.modal_wrap[data-modal=${modalName}] .main_phone_li`);

                $(`.modal_wrap[data-modal=${modalName}]`).addClass('js_open_modal');
                break;

            case 'editWishlist':
                const objectEditWishlist = {
                    "name_list": $(this)
                        .closest('.js_block_account_list_wishlist')
                        .find('.js__rename').text().trim(),
                    "wishlist_id": $(this).attr('data-wishlist_id')
                }

                editWishlist(objectEditWishlist);
                break;

            case 'makeBid':
                const objectMakeBid = {
                    'guid': $(this).attr('data-guid'),
                    'item_type': $(this).attr('data-item_type'),
                    'id': $(this).attr('data-id'),
                    'itemListNameGtm': $(this).attr('data-itemListNameGtm'),
                    'indexGtm': $(this).attr('data-indexGtm'),
                }

                makeBid(modalName, objectMakeBid);
                break;

            default:
                if (typeof $(this).attr('data-addwish') !== 'undefined' && $(this).attr('data-addwish') == 'unLogin') {
                    $(`.modal_wrap[data-modal=${modalName}]`).find('.title_modal').empty().text(titleLogin.loginWishlist);
                } else {
                    modalName == 'loginAccount'
                        ? $(`.modal_wrap[data-modal=${modalName}]`).find('.title_modal').empty().text(titleLogin.login)
                        : '';
                }
                $(`.modal_wrap[data-modal=${modalName}]`).addClass('js_open_modal');
                break;
        }
    });


    $(document).on('click', '.js_close_modal', function () {
        const btn = $(this);
        const remove = btn.attr('data-remove');
        if (remove) {
            const wrapper = btn.closest('.modal_wrap');
            wrapper.remove();
        } else {
            $('.modal_wrap').removeClass('js_open_modal');
        }

        if ($('.bg_modal_window').length > 0) {
            $('.bg_modal_window').remove();
        }

        if ($(this).closest('.modal_wrap').find('.text_error').length != 0) {
            $(this).closest('.modal_wrap').find('.input_error').removeClass('input_error');
            $(this).closest('.modal_wrap').find('.text_error').remove();
        }

        $('.remove_wishlist').remove();
        $('.btn_buy').removeClass('btn_buy');
        $('.js__anker_here').removeClass('js__anker_here');
    });

    $(document).on('click', '.bg_modal_window', function () {
        $('.bg_modal_window').remove();
        $('.modal_wrap').removeClass('js_open_modal');

        if ($('.modal_wrap').find('.text_error').length != 0) {
            $('.modal_wrap').find('.input_error').removeClass('input_error');
            $('.modal_wrap').find('.text_error').remove();
        }

        $('.btn_buy').removeClass('btn_buy');
        $('.remove_wishlist').remove();
        $('.js__anker_here').removeClass('js__anker_here');
    });

    function buyOneClickProductPage(name, tile = false, dataBueClick = 0) {
        let form = "";
        if (tile) {
            form = `
            <form class="form_buy_click js__buy_one_click_modal js_form_validate" autocomplete="off" onkeydown="return event.key != 'Enter';">
                <div class="input_wrapper">
                    <input type="text" class="js__mask_phone input_input" data-error="phone" required placeholder="Телефон" name="phone">
                </div>
                <input type="hidden" name="guid" value=${dataBueClick['guid']}>
                <input type="hidden" name="id" value=${dataBueClick['id']}>
                <input type="hidden" name="item_type" value="${dataBueClick['item_type']}">
                <input type="hidden" name="quantity" value="${dataBueClick['quantity']}">
                <input type="hidden" name="price_type_id" value="${dataBueClick['price_type_id']}">
                <button class="submit_bue_click js_valid_form" type="button"
                    data-success="good" data-indexGtm="${dataBueClick['indexGtm']}" 
                    data-itemListNameGtm="${dataBueClick['itemListNameGtm']}" >
                        ${dataBueClick['name']}
                </button>
            </form>`;
        } else {
            form = `<form class="form_buy_click js__buy_one_click_modal js_form_validate"> ${$('.form_buy_click').html()} </form>`;
        }
        $(`.modal_wrap[data-modal=${name}]`).addClass('js_open_modal').find('.modal_middle').empty().append(form);
        $('.js__buy_one_click_modal .js_valid_form').removeClass('js__name_form');
        const value = {
            "guid": $('.form_buy_click input[name=guid]').val(),
            "id": $('.form_buy_click input[name=id]').val(),
            "item_type": $('.form_buy_click input[name=item_type]').val(),
            "quantity": $('.form_buy_click input[name=quantity]').val(),
        }
        if (contact_phone) {
            $('input.js__mask_phone').val(contact_phone);
        }
        if (contact_first_name) {
            $('input[name="first_name"]').val(contact_first_name);
        }

        $.post(request.buyOneClickDataGtm, value, function (data) {
            if (data.status == 'ok') {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "add_to_cart",
                    label: "by_one_click",
                    ecommerce: {
                        items: [{
                            item_name: data.data.name,
                            item_id: String(data.data.good_id),
                            price: Number(data.data.price),
                            item_brand: data.data.brand,
                            item_category: data.data.cat1 != "" ? data.data.cat1 : null,
                            item_category2: data.data.cat2 != "" ? data.data.cat2 : null,
                            item_category3: data.data.cat3 != "" ? data.data.cat3 : null,
                            item_variant: data.data.status,
                            item_list_name: $('.js__buy_one_click_modal .js_valid_form').attr('data-itemListNameGtm'),
                            index: Number($('.js__buy_one_click_modal .js_valid_form').attr('data-indexGtm')),
                            quantity: data.data.quantity
                        }]
                    }
                });

            }
        });
        phoneMask();

        if (typeof CheckoutStorage.nameStorage !== 'undefined' && typeof is_user !== 'undefined' && is_user == '') {
            let storedValues = CheckoutStorage.getCookie(CheckoutStorage.nameStorage);

            if (storedValues.phone) {
                $('.js__mask_phone').val(storedValues.phone);
            }
        }
    }

    function addToWaitlist(modalName, data = 0) {
        const parent = $('.modal_wrap[data-modal="addToWaitlist"]');
        parent.find('.js__id').val(data['id']);
        parent.find('.js_item_type').val(data['itemType']);

        $(`.modal_wrap[data-modal=${modalName}]`).addClass('js_open_modal');
    }

    function goodSignService(modalName, data) {
        const parent = $(`.modal_wrap[data-modal=${modalName}]`);
        parent.find('.modal_service_article').val(data.article)
        parent.find('.modal_service_id').val(data.id);
        parent.find('.js__gtm_data_hidden').attr('data-service', data.serviceName);


        $(`.modal_wrap[data-modal=${modalName}]`).addClass('js_open_modal');
    }

    function callbackServiceAddress(modalName, items, firstItem, typePage) {
        $(`.modal_wrap[data-modal=${modalName}]`)
            .find('.input_drop_points').empty().append(items);

        $(`.modal_wrap[data-modal=${modalName}]`)
            .find('.input_drop_points li').addClass('input_drop_point button')

        $(`.modal_wrap[data-modal=${modalName}]`)
            .find('.js_input_button_service').text(firstItem['name'])
            .attr({
                "data-valueButton": firstItem['id']
            });
        $(`.modal_wrap[data-modal=${modalName}]`)
            .find('.js_modal_service_article').val(firstItem['article']);

        $(`.modal_wrap[data-modal=${modalName}]`).find('.js__gtm_data_hidden')
            .attr({ "data-city": firstItem['city'], "data-address": firstItem['address'], "data-service": firstItem['name'] });

        $(`.modal_wrap[data-modal=${modalName}]`).addClass('js_open_modal');

        $(`.modal_wrap[data-modal=${modalName}]`).attr(`data-typePage`, typePage);

        $(`.modal_wrap[data-modal=${modalName}] .js__modal_type_service_id`).val(firstItem['id']);
        $(`.modal_wrap[data-modal=${modalName}] .js__modal_type_service_city`).val(firstItem['city_id']);
        $(`.modal_wrap[data-modal=${modalName}] .js__modal_type_service_address`).val(firstItem['address_id']);
    }

    function returnGoodModal(modalName, data) {
        if (modalName == "returnGood") {
            $(`.modal_wrap[data-modal=${modalName}]`).find('.js__return_good_name')
                .text(`"${data.name}"`)
            delete data.name;
        }
        for (var input in data) {
            $(`.modal_wrap[data-modal=${modalName}]`)
                .find('.js__return_good_form').append(`<input type="hidden" class="js__input_return"
                 name="${input}" value="${data[input]}">`);
        }
        $(`.modal_wrap[data-modal=${modalName}]`).addClass('js_open_modal');
    }

    function makeBid(modalName, data) {
        const modal = $(`.modal_wrap[data-modal=${modalName}]`);

        modal.find('input[name=guid]').val(data.guid);
        modal.find('input[name=id]').val(data.id);
        modal.find('input[name=item_type]').val(data.item_type);

        modal.find('.js_valid_form').attr('data-indexGtm', data.indexGtm);
        modal.find('.js_valid_form').attr('data-itemListNameGtm', data.itemListNameGtm);

        $(`.modal_wrap[data-modal=${modalName}]`).addClass('js_open_modal');
    }
});